
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.848 4.437V2.535a.5.5 0 00-.5-.5H4.935a2.902 2.902 0 00-2.902 2.902v12.01a.5.5 0 00.5.5h14.95a.5.5 0 00.5-.5V4.937a.5.5 0 00-.5-.5h-1.635zm-12.748 0h11.748V3.035H4.935c-.877 0-1.616.594-1.835 1.402zm13.315 3.641h-4.407a2 2 0 00-2 2v.434a2 2 0 002 2h4.407V8.078z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.664 10.252a1 1 0 11-2 0 1 1 0 012 0z","fill":"currentColor"}})])
          )
        }
      }
    